/**
 * The sword form practised over and over (`kata`), the recoveries from plain blows back into the
 * fighting stance, and settling out of it.
 */
import type { MotionDef } from './kit';

export const MOTIONS = [
  {
    id: 'kata',
    keys: ['ready', 'windup', 'cut', 'follow', 'lowGuard', 'thrust', 'overhead', 'cut'],
    ease: ['inOut', 'in', 'out', 'inOut', 'in', 'inOut', 'in', 'inOut'],
    loop: true,
  },
  // Recovering from a plain blow: from where each swing ends (cleave and thrust on `follow`, the
  // rising cut on `atk`, the overhead on `cut`) back up into the fighting stance, so the next
  // frame of `ready` follows on without a jump.
  { id: 'recoverFollow', keys: ['follow', 'ready'], ease: ['inOut'] },
  { id: 'recoverAtk', keys: ['atk', 'ready'], ease: ['inOut'] },
  { id: 'recoverCut', keys: ['cut', 'ready'], ease: ['inOut'] },
  // Out of the fighting stance once the fight is over, standing up at ease (played backwards, into it).
  { id: 'settle', keys: ['ready', 'idle'], ease: ['inOut'] },
] as const satisfies readonly MotionDef[];
